import Vue from 'vue';

// Por ahora sólo hay este filtro, si en algún momento tuviesemos más podríamos
// sacar cada uno a su respectivo fichero.
export default () => {
  Vue.filter('formatDate', (value) => {
    if (value) {
      const today = new Date(value);
      today.toLocaleDateString('es-ES');
      const day = today.getDate().toString().padStart(2, '0');
      const month = today.toLocaleString('default', { month: 'long' });
      const hours = today.getHours().toString().padStart(2, '0');
      const minutes = today.getMinutes().toString().padStart(2, '0');
      return `${day} de ${month} de ${today.getFullYear()}. ${hours}:${minutes}`;
    }

    return null;
  });
};
